<template>
  <div class="bottomParts">
    <warnPart></warnPart>
    <energyPart></energyPart>
    <cleancarPart></cleancarPart>
    <doorPart></doorPart>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import cleancarPart from "./cleancar_part";
import doorPart from "./door_part";
import energyPart from "./energy_part";
import warnPart from "./warn_part";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { cleancarPart, doorPart, energyPart, warnPart },
  props: {},
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  //方法集合
  methods: {},
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped='scoped'>
.bottomParts {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: skyblue;
  justify-content: space-between;
  .warnPart {
    width: 24.625%;
    height: 100%;
    background-color: olive;
  }
  .energyPart {
    width: 24.625%;
    height: 100%;
    background-color:orange
  }
  .cleancarPart {
    width: 24.625%;
    height: 100%;
    background-color:rgb(0, 132, 255)
  }
  .doorPart {
    width: 24.625%;
    height: 100%;
    background-color:rgb(115, 255, 0)
  }
}
</style>